import { BlocksIconChevronLeft } from 'blocks-nextjs/blocks-web-components/components/icon/icons/chevron-left';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconChevronLeft = createComponent({ react: React, tagName: 'cat-icon-chevron-left', elementClass: BlocksIconChevronLeft });
